module.exports = __webpack_public_path__ + "img/inst-modal-1.674028ac.png";